/**
 * @generated SignedSource<<70148aeac3ae293b67d7b81b331e0137>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventJobLogSizeExceeded_event$data = {
  readonly timestamp: any;
  readonly " $fragmentType": "JobEventJobLogSizeExceeded_event";
};
export type JobEventJobLogSizeExceeded_event$key = {
  readonly " $data"?: JobEventJobLogSizeExceeded_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventJobLogSizeExceeded_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventJobLogSizeExceeded_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "c274deecb826b8f727086687dc6fc73b";

export default node;
